import "../App.css";

import Navbar from "../components/navbar"
import Warning from "../components/warning";
import Footer from "../components/footer";
import { Helmet } from "react-helmet";

import { useInView } from "react-intersection-observer";

const FadeInTitle = ({ children }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <p ref={ref} className={`fade-in Sector Concert Center Cyan ${inView ? "visible" : ""}`}>
      {children}
    </p>
  );
};

const Technician = () => {
  return (
    <div className="App">
      <Helmet>
        <title>Heartland Fun: Technician Info</title>
        <meta name="title" content="Heartland Fun: Technician Info" />
        <meta name="description" content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta name="keywords" content="Arcade equipment, Claw machines, Gaming systems, Amusement supplier, Business entertainment, Arcade experience, Hassle-free purchasing, Entertainment solutions, Fun equipment, Gaming for businesses" />
        <meta name="robots" content="index, follow" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta property="og:title" content="Heartland Fun: Technician Info" />
        <meta property="og:type" content="website" />
        <meta property="og:description " content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta property="og:determiner " content="" />
        <meta property="og:url" content="https://heartland.csfrederick.com/technician" />
        <meta property="og:image" content="https://heartland.csfrederick.com/Header.png" />
        <meta property="og:image:secure_url" content="https://heartland.csfrederick.com/Header.png" />
        <link rel="icon" href="/favicon.ico" />
      </Helmet>
      <Navbar></Navbar>
      <Warning></Warning>
      <FadeInTitle>
        TECHNICIAN SERVICES
      </FadeInTitle>
      <br></br>
      <a href="tel:7858137921" className="Button Titillium Center">
        Contact a Technical Expert
      </a>
      <div className="Brake"></div>
      <p className="Blue InfoText Titillium Center FadeIn">
        If you are in need of dependable technical services to help you with setting up, sourcing a hard-to-find part, or repairing a malfunctioning machine, then you have come to the right place. Our team of experts is readily available to provide you with the assistance you require. So, if you are looking for top-notch services, do not hesitate to get in touch with us today. We are always happy to help!
      </p>
      <Footer></Footer>
    </div>
  );
};

export default Technician;